var _g, _path, _path2, _line, _line2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestSellernew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 71,
    viewBox: "0 0 44 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_14796_16209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 1H6C5.44772 1 5 1.44772 5 2V51.5436C5 52.2455 5.70418 52.729 6.35922 52.4768L38.3592 40.1598C38.7453 40.0112 39 39.6402 39 39.2265V2C39 1.44772 38.5523 1 38 1Z",
    fill: "url(#paint0_linear_14796_16209)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1255 15.395L14.2207 14.878C14.9359 14.7016 15.4991 14.7411 15.9103 14.9967C16.3194 15.2439 16.6091 15.7125 16.7793 16.4025L16.8665 16.7559C16.9786 17.2103 16.9943 17.5992 16.9134 17.9226C16.8409 18.244 16.6688 18.5052 16.397 18.7061L16.4033 18.7314C17.1514 18.7968 17.6479 19.3259 17.8929 20.3188L18.0797 21.0761C18.2479 21.7576 18.1957 22.324 17.9232 22.775C17.6569 23.2156 17.1789 23.5211 16.4889 23.6913L14.3054 24.23L12.1255 15.395ZM14.9441 18.5156C15.2218 18.4471 15.4103 18.3248 15.5096 18.1485C15.6174 17.9702 15.6297 17.7127 15.5467 17.3761L15.4252 16.8839C15.3463 16.5641 15.2303 16.3473 15.0773 16.2333C14.9326 16.1172 14.7382 16.0893 14.4942 16.1495L13.8253 16.3146L14.4014 18.6496L14.9441 18.5156ZM16.1775 22.4291C16.4215 22.3689 16.5868 22.2612 16.6735 22.1059C16.7581 21.9422 16.7609 21.7005 16.682 21.3808L16.4921 20.6108C16.3924 20.207 16.2524 19.9469 16.072 19.8308C15.8979 19.7041 15.651 19.6802 15.3312 19.7591L14.7128 19.9117L15.3823 22.6253L16.1775 22.4291ZM17.2283 14.136L21.0148 13.2017L21.3262 14.4639L18.9281 15.0556L19.5042 17.3905L21.4101 16.9203L21.7215 18.1825L19.8156 18.6527L20.4852 21.3663L22.8832 20.7746L23.1946 22.0368L19.4082 22.971L17.2283 14.136ZM25.854 21.5145C25.1809 21.6806 24.6251 21.6169 24.1867 21.3234C23.7462 21.0214 23.4377 20.5129 23.2613 19.7976L23.1367 19.2928L24.4493 18.9689L24.5988 19.5747C24.74 20.1469 25.0504 20.3738 25.53 20.2555C25.7656 20.1974 25.9257 20.0865 26.0103 19.9228C26.1012 19.7486 26.1082 19.5058 26.0314 19.1945C25.9401 18.8243 25.776 18.5211 25.5392 18.2849C25.3003 18.0404 24.9049 17.7764 24.353 17.493C23.6562 17.1293 23.1445 16.7736 22.8176 16.4257C22.4887 16.0695 22.2609 15.6347 22.1343 15.1215C21.962 14.4231 22.0058 13.8409 22.2658 13.3751C22.5237 12.9009 22.9892 12.5807 23.6624 12.4146C24.3271 12.2506 24.8755 12.3206 25.3076 12.6246C25.746 12.9181 26.0534 13.4225 26.2299 14.1377L26.3202 14.5038L25.0076 14.8276L24.8954 14.3732C24.8207 14.0703 24.7078 13.8661 24.5568 13.7605C24.4037 13.6465 24.2136 13.6176 23.9864 13.6736C23.5236 13.7878 23.3618 14.1268 23.5009 14.6906C23.5797 15.0103 23.7376 15.2882 23.9744 15.5244C24.2196 15.7585 24.6182 16.0172 25.1701 16.3006C25.8753 16.6622 26.3881 17.0221 26.7086 17.3805C27.0291 17.7388 27.2579 18.1956 27.3949 18.751C27.5734 19.4746 27.5295 20.0746 27.2632 20.5509C27.0053 21.0252 26.5356 21.3464 25.854 21.5145ZM27.9311 12.8343L26.4796 13.1924L26.1682 11.9302L30.4595 10.8714L30.7709 12.1336L29.3195 12.4917L31.1879 20.0646L29.7995 20.4072L27.9311 12.8343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8848 36.7947C11.2117 36.9608 10.6559 36.8971 10.2175 36.6036C9.77701 36.3016 9.46854 35.793 9.29207 35.0778L9.1675 34.573L10.4801 34.2491L10.6296 34.8549C10.7708 35.4271 11.0812 35.654 11.5608 35.5357C11.7964 35.4775 11.9565 35.3666 12.0411 35.2029C12.132 35.0288 12.1391 34.786 12.0622 34.4747C11.9709 34.1044 11.8068 33.8012 11.57 33.5651C11.3311 33.3205 10.9357 33.0566 10.3838 32.7732C9.68704 32.4095 9.17525 32.0538 8.84841 31.7059C8.51949 31.3497 8.29172 30.9149 8.16507 30.4016C7.99276 29.7033 8.03659 29.1211 8.29656 28.6553C8.55447 28.181 9.01999 27.8609 9.69314 27.6948C10.3579 27.5308 10.9063 27.6008 11.3383 27.9048C11.7768 28.1983 12.0842 28.7027 12.2607 29.4179L12.351 29.7839L11.0383 30.1078L10.9262 29.6534C10.8515 29.3505 10.7386 29.1463 10.5876 29.0407C10.4345 28.9267 10.2444 28.8978 10.0172 28.9538C9.55438 29.068 9.39254 29.407 9.53164 29.9707C9.61053 30.2905 9.76838 30.5684 10.0052 30.8046C10.2504 31.0387 10.649 31.2974 11.2009 31.5807C11.9061 31.9423 12.4189 32.3023 12.7394 32.6606C13.0599 33.019 13.2887 33.4758 13.4257 34.0311C13.6042 34.7548 13.5603 35.3547 13.294 35.8311C13.0361 36.3053 12.5664 36.6265 11.8848 36.7947ZM12.565 27.1201L16.3514 26.1858L16.6629 27.448L14.2648 28.0397L14.8409 30.3747L16.7467 29.9044L17.0582 31.1666L15.1523 31.6368L15.8219 34.3504L18.2199 33.7587L18.5314 35.0209L14.7449 35.9551L12.565 27.1201ZM17.1502 25.9888L18.5385 25.6462L20.407 33.2191L22.6915 32.6555L23.0029 33.9176L19.3301 34.8238L17.1502 25.9888ZM21.4888 24.9183L22.8772 24.5757L24.7456 32.1486L27.0301 31.585L27.3416 32.8471L23.6687 33.7533L21.4888 24.9183ZM25.8274 23.8478L29.6139 22.9136L29.9253 24.1757L27.5272 24.7674L28.1033 27.1024L30.0092 26.6321L30.3206 27.8943L28.4147 28.3645L29.0843 31.0781L31.4824 30.4864L31.7938 31.7486L28.0073 32.6828L25.8274 23.8478ZM30.4126 22.7165L32.4699 22.2089C33.1851 22.0324 33.7483 22.072 34.1595 22.3276C34.5686 22.5748 34.8583 23.0434 35.0286 23.7333L35.1625 24.2761C35.3888 25.1932 35.2291 25.8485 34.6835 26.242L34.6897 26.2673C35.0512 26.2852 35.3377 26.4332 35.5491 26.7113C35.769 26.9874 35.9433 27.3862 36.072 27.9079L36.455 29.4604C36.5173 29.7128 36.5766 29.9169 36.6328 30.0726C36.687 30.2199 36.7665 30.361 36.8712 30.4958L35.4576 30.8446C35.3718 30.714 35.3049 30.5877 35.2569 30.4656C35.209 30.3436 35.1445 30.1185 35.0635 29.7903L34.6649 28.1748C34.5653 27.7709 34.4284 27.5056 34.2543 27.3789C34.0887 27.2502 33.846 27.2253 33.5262 27.3042L33.0466 27.4225L33.9808 31.209L32.5925 31.5515L30.4126 22.7165ZM33.24 26.0358C33.5177 25.9673 33.7062 25.8449 33.8056 25.6686C33.9133 25.4903 33.9257 25.2329 33.8426 24.8963L33.6745 24.2147C33.5956 23.895 33.4796 23.6781 33.3265 23.5641C33.1818 23.4481 32.9874 23.4202 32.7434 23.4804L32.1124 23.6361L32.7352 26.1604L33.24 26.0358Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.92572,
    y1: 13.7912,
    x2: 33.4176,
    y2: 7.69058,
    stroke: "white",
    strokeWidth: 0.638338
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.9052,
    y1: 39.6896,
    x2: 36.3971,
    y2: 33.589,
    stroke: "white",
    strokeWidth: 0.638338
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_14796_16209",
    x: 0,
    y: 0,
    width: 44,
    height: 70.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14796_16209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14796_16209",
    result: "effect2_dropShadow_14796_16209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_14796_16209",
    result: "effect3_dropShadow_14796_16209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_14796_16209",
    result: "effect4_dropShadow_14796_16209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_14796_16209",
    result: "effect5_dropShadow_14796_16209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_14796_16209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14796_16209",
    x1: 22,
    y1: 1,
    x2: 22,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328BC0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSellernew);
export default __webpack_public_path__ + "static/media/BestSellernew.92d0c9cf5c635536c7d8632dd8dba206.svg";
export { ForwardRef as ReactComponent };